let _channel = {
	Shifts: [],
	Questions: null,
	Address: null,
	Directory: null,
	Payment: null,
	Fields: null,
	Terms: null,
	hasImprint: false,
	Mode: "Shifts",
	Dates: [],
	Theme: null,
	UserProfile: null,
	isLoaded: false,
	bearerToken: null
};

export default _channel;